import { ButtonCheckbox, SaveableCard } from "@jasper/forms";
import { Group, Select, SimpleGrid, Stack, Text } from "@mantine/core";
import { withForm } from "../../../hooks/preferenceForm";
import { usePreferenceCardSave } from "../../../hooks/usePreferenceCardSave";
import { getRemovablePreferenceDefaults } from "../removablePreferenceForm";

const FRAMEWORKS = ["Stellite Co-Cr", "Titane"];
const ATTACHMENTS = ["Aucun", "Glissière", "Bouton-pression"];
const CLASPS = ["Coulé", "Crochet PAP", "Valplast", "Acétal", "Transparent"];
const METAL_FRAMEWORKS = ["Couler dès la cire", "Attendre l'essayage"];

export const PartialDenturePreferences = withForm({
  defaultValues: getRemovablePreferenceDefaults(),
  render: function Render({ form }) {
    const { status, save } = usePreferenceCardSave(form, [
      "partialFramework",
      "partialAttachment",
      "partialClasps",
      "partialMetalFramework",
    ]);

    return (
      <SaveableCard
        title="Amovible partielle"
        description="Châssis, crochets et attachements"
        status={status}
        onSave={save}
      >
        <Stack gap="s3">
          <SimpleGrid cols={2}>
            <Stack gap="s2">
              <Text variant="strong">Châssis</Text>
              <form.Field name="partialFramework">
                {field => (
                  <Select
                    data={FRAMEWORKS}
                    value={field.state.value}
                    onChange={field.handleChange}
                  />
                )}
              </form.Field>
            </Stack>
            <Stack gap="s2">
              <Text variant="strong">Attachement de précision</Text>
              <form.Field name="partialAttachment">
                {field => (
                  <Select
                    data={ATTACHMENTS}
                    value={field.state.value}
                    onChange={field.handleChange}
                  />
                )}
              </form.Field>
            </Stack>
          </SimpleGrid>
          <>
            <Text variant="strong">Crochets</Text>
            <form.Field name="partialClasps">
              {field => (
                <Group>
                  {CLASPS.map(option => (
                    <ButtonCheckbox
                      key={option}
                      id={option}
                      isActive={field.state.value === option}
                      onClick={() => field.handleChange(option)}
                    >
                      {option}
                    </ButtonCheckbox>
                  ))}
                </Group>
              )}
            </form.Field>
          </>
          <>
            <Text variant="strong">Châssis métallique</Text>
            <form.Field name="partialMetalFramework">
              {field => (
                <Group>
                  {METAL_FRAMEWORKS.map(option => (
                    <ButtonCheckbox
                      key={option}
                      id={option}
                      isActive={field.state.value === option}
                      onClick={() => field.handleChange(option)}
                    >
                      {option}
                    </ButtonCheckbox>
                  ))}
                </Group>
              )}
            </form.Field>
          </>
        </Stack>
      </SaveableCard>
    );
  },
});
